module.exports = __webpack_public_path__ + "img/Payments.4957a341.svg";